import axios from 'axios'
import Cookies from 'js-cookie'
import {
  CHECKEMAILID_API,
  LOGIN_API,
  MAIN_URL,
  RESETPASSWORD_API,
  SIGNUP_API,
  VERIFYLINK_API,
  GET_ALL_USER_API,
  UPDATE_USER_STATUS_API,
  GET_ALL_CUSTOMER_API,
  GET_ALL_STATE_API,
  ADD_STATE_API,
  UPDATE_STATE_API,
  GET_ALL_CITY_API,
  ADD_CITY_API,
  UPDATE_CITY_API,
  GET_CITY_BY_STATE_ID_API,
  CHANGE_CITY_STATUS_API,
  GET_ALL_VENUE_API,
  ADD_VENUE_API,
  UPDATE_VENUE_API,
  DELETE_VENUE_API,
  GET_VENUE_BY_CITY_ID_API,
  GET_ALL_CATEGORY_API,
  ADD_CATEGORY_API,
  UPDATE_CATEGORY_API,
  DELETE_CATEGORY_API,
  GET_ALL_EVENT_API,
  ADD_EVENT_API,
  UPDATE_EVENT_API,
  DELETE_EVENT_API,
  GET_ALL_EVENT_DAY_API,
  ADD_EVENT_DAY_API,
  UPDATE_EVENT_DAY_API,
  DELETE_EVENT_DAY_API,
  GET_EVENT_DAY_BY_EVENT_ID_API,
  GET_ALL_EVENT_SCHEDULE_API,
  ADD_EVENT_SCHEDULE_API,
  UPDATE_EVENT_SCHEDULE_API,
  DELETE_EVENT_SCHEDULE_API,
  GET_EVENT_SCHEDULE_BY_DAY_ID_API,
  GET_ALL_EVENT_PRESENTER_API,
  ADD_EVENT_PRESENTER_API,
  UPDATE_EVENT_PRESENTER_API,
  DELETE_EVENT_PRESENTER_API,
  GET_EVENT_PRESENTER_BY_SESSION_ID_API,
  GET_APP_SETTINGS_API,
  UPDATE_APP_SETTINGS_API,
  GET_ALL_SPONSOR_API,
  ADD_SPONSOR_API,
  UPDATE_SPONSOR_API,
  DELETE_SPONSOR_API,
  GET_ALL_BLOG_API,
  ADD_BLOG_API,
  UPDATE_BLOG_API,
  DELETE_BLOG_API,
  GET_ALL_CONTACT_US_API,
  GET_ALL_CUPONCODE_API,
  ADD_CUPONCODE_API,
  UPDATE_CUPONCODE_API,
  GET_ALL_ORDER_API,
  GET_INCOME_API,
  GET_DAYWISE_INCOME_API,
  GET_LOGIN_STATS_API,
  GET_TOTAL_COUNT_API,
  GET_REVIEW_BY_EVENT_ID_API,
  GET_THEME_API,
  UPDATE_THEME_API,
  GET_APP_SETTINGS_API_FAVICON,
  GET_ALL_EVENT_SPONSOR_API,
  ADD_EVENT_SPONSOR_API,
  UPDATE_EVENT_SPONSOR_API,
  DELETE_EVENT_SPONSOR_API,
  GET_EVENT_SPONSOR_BY_EVENT_ID_API,
  GET_ALL_POPUP_IMAGE_API,
  ADD_POPUP_IMAGE_API,
  UPDATE_POPUP_IMAGE_API,
  GET_EVENT_TICKET_API,
  GET_ORDER_BY_ID_API,
  CHANGEPASSEORD_API,
  GET_ALL_ADMIN_API,
  CREATE_ROLE,
  GET_ALL_ROLE,
  UPDATE_ROLE_ID,
  CREATE_SCREEN,
  UPDATE_SCREEN,
  GET_ALL_SCREENS,
  CREATE_TICKET_CLASS_API,
  SAVE_TICKET_TEMPLATE_API,
  GET_TICKET_TEMPLATE_API,
  DELETE_TICKET_TEMPLATE_API,
  DUPLICATE_TICKET_TEMPLATE_API,
  GET_TICKET_TEMPLATE_BY_ID_API,
  GET_CATEGORY_API,
  GET_CITY_API,
  MAIN_API,
  GET_COUNT_API,
  GET_FEATURED_EVENT_API,
  GET_LATEST_BLOG_API,
  GET_STATE_API,
  GET_SPONSOR_API,
} from '../../constant'
import {
  GET_ADVERTISEMENT_META_API,
  GET_ADVERTISEMENT_SUMMARY_API,
  GET_ALL_ADVERTISEMENT_API,
  GET_ADVERTISEMENT_BY_ID_API,
  ADD_ADVERTISEMENT_API,
  UPDATE_ADVERTISEMENT_API,
  DUPLICATE_ADVERTISEMENT_API,
  PUBLISH_ADVERTISEMENT_API,
  PAUSE_ADVERTISEMENT_API,
  RESUME_ADVERTISEMENT_API,
  ARCHIVE_ADVERTISEMENT_API,
  DELETE_ADVERTISEMENT_API,
  UPLOAD_ADVERTISEMENT_CREATIVE_API,
  TEST_ADVERTISEMENT_TARGETING_API,
  GET_ADVERTISEMENT_ANALYTICS_API,
  EXPORT_ADVERTISEMENT_ANALYTICS_API,
  GET_APP_SERVICE_META_API,
  GET_ALL_APP_SERVICE_API,
  GET_APP_SERVICE_BY_ID_API,
  ADD_APP_SERVICE_API,
  UPDATE_APP_SERVICE_API,
  REORDER_APP_SERVICE_API,
  DELETE_APP_SERVICE_API,
  UPLOAD_APP_SERVICE_ICON_API,
  GET_APP_THEME_API,
  UPDATE_APP_THEME_API,
  RESET_APP_THEME_API,
  GET_APP_VERSION_API,
  UPDATE_APP_VERSION_API,
} from '../../constant'
import { PERMISSION } from '../actions/action'
import { useDispatch } from 'react-redux'

axios.interceptors.response.use(
  (response) => response,
  async (err) => {
    const originalRequest = err.config

    if (err.status == 402 && !originalRequest._retry) {
      originalRequest._retry = true

      // Cookies.remove('accessToken')
      // Cookies.remove('refreshToken')
      // Cookies.remove('permission')
      // window.location.reload()
      try {
        const refreshToken = Cookies.get('refreshToken')

        const res = await axios.post(`${MAIN_URL}/api/admin/refreshtoken`, { refreshToken })

        const accessToken = res.data.info

        Cookies.set('token', accessToken, { sameSite: 'Strict', secure: true })

        // Retry the original request with the new token
        originalRequest.headers.Authorization = `Bearer ${accessToken}`

        return axios(originalRequest)
      } catch (refresherr) {
        // console.log('err refreshing token:', refresherr)
        // You might want to redirect to login or handle the err in another way
      }
    }

    if (err.status === 405) {
      Cookies.remove('accessToken')
      // window.location.reload()
    }
    return Promise.reject(err)
  },
)

// /* Get All General Seetings  */
// export const getGeneralSettings = () =>
//   axios.get(MAIN_URL + GET_GENERAL_SETTINGS_API, {
//     headers: { Authorization: `Bearer ${Cookies.get('accessToken')}` },
//   })

/* ---------------------------- ALL GENERAL SETTINGS API ---------------------------- */

export const loginapi = (data) => axios.post(MAIN_URL + LOGIN_API, data)

export const signupapi = (data) => axios.post(MAIN_URL + SIGNUP_API, data)
export const checkemailidapi = (data) => axios.post(MAIN_URL + CHECKEMAILID_API, data)
export const verifylinkapi = (data) => axios.post(MAIN_URL + VERIFYLINK_API, data)
export const resetpasswordapi = (data) => axios.post(MAIN_URL + RESETPASSWORD_API, data)
export const ChangePasswordapi = (data) =>
  axios.post(MAIN_URL + CHANGEPASSEORD_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

/* ---------------------------- END GENERAL SETTINGS API ---------------------------- */

/* ---------------------------- ALL User API ---------------------------- */
export const getAllUserApi = () =>
  axios.get(MAIN_URL + GET_ALL_USER_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getAllCustomerApi = () =>
  axios.get(MAIN_URL + GET_ALL_CUSTOMER_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getAllAdminApi = () =>
  axios.get(MAIN_URL + GET_ALL_ADMIN_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })


export const updateUserStatusApi = (data) =>
  axios.post(MAIN_URL + UPDATE_USER_STATUS_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END User API ---------------------------- */

/* ---------------------------- ALL State API ---------------------------- */
export const getAllStateApi = () => axios.get(MAIN_URL + GET_ALL_STATE_API)

export const addStateApi = (data) =>
  axios.post(MAIN_URL + ADD_STATE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateStateApi = (data) =>
  axios.post(MAIN_URL + UPDATE_STATE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END State API ---------------------------- */

/* ---------------------------- ALL City API ---------------------------- */
export const getAllCityApi = () => axios.get(MAIN_URL + GET_ALL_CITY_API)

export const addCityApi = (data) =>
  axios.post(MAIN_URL + ADD_CITY_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateCityApi = (data) =>
  axios.post(MAIN_URL + UPDATE_CITY_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const changeCityStatusApi = (data) =>
  axios.post(MAIN_URL + CHANGE_CITY_STATUS_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getCityByStateIdApi = (data) =>
  axios.post(MAIN_URL + GET_CITY_BY_STATE_ID_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

/* ---------------------------- END City API ---------------------------- */

/* ---------------------------- ALL Venue API ---------------------------- */
export const getAllVenueApi = () => axios.get(MAIN_URL + GET_ALL_VENUE_API)

export const addVenueApi = (data) =>
  axios.post(MAIN_URL + ADD_VENUE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
export const updateVenueApi = (data) =>
  axios.post(MAIN_URL + UPDATE_VENUE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
export const deleteVenueApi = (data) =>
  axios.post(MAIN_URL + DELETE_VENUE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
export const getVenueByCityIdApi = (data) =>
  axios.post(MAIN_URL + GET_VENUE_BY_CITY_ID_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

/* ---------------------------- END Venue API ---------------------------- */

/* ---------------------------- ALL Category API ---------------------------- */
export const getAllCategoryApi = () =>
  axios.get(MAIN_URL + GET_ALL_CATEGORY_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const addCategoryApi = (data) =>
  axios.post(MAIN_URL + ADD_CATEGORY_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateCategoryApi = (data) =>
  axios.post(MAIN_URL + UPDATE_CATEGORY_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const deleteCategoryApi = (data) =>
  axios.post(MAIN_URL + DELETE_CATEGORY_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Category API ---------------------------- */

/* ---------------------------- ALL Event API ---------------------------- */
export const getAllEventApi = () =>
  axios.get(MAIN_URL + GET_ALL_EVENT_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const addEventApi = (data) =>
  axios.post(MAIN_URL + ADD_EVENT_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateEventApi = (data) =>
  axios.post(MAIN_URL + UPDATE_EVENT_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const deleteEventApi = (data) =>
  axios.post(MAIN_URL + DELETE_EVENT_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getReviewByEventIdApi = (data) =>
  axios.post(MAIN_URL + GET_REVIEW_BY_EVENT_ID_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getEventTicketApi = (data) =>
  axios.post(MAIN_URL + GET_EVENT_TICKET_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Event API ---------------------------- */

/* ---------------------------- ALL Event Day API ---------------------------- */
export const getAllEventDayApi = () =>
  axios.get(MAIN_URL + GET_ALL_EVENT_DAY_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const addEventDayApi = (data) =>
  axios.post(MAIN_URL + ADD_EVENT_DAY_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateEventDayApi = (data) =>
  axios.post(MAIN_URL + UPDATE_EVENT_DAY_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const deleteEventDayApi = (data) =>
  axios.post(MAIN_URL + DELETE_EVENT_DAY_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getEventDayByEventIdApi = (data) =>
  axios.post(MAIN_URL + GET_EVENT_DAY_BY_EVENT_ID_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Event Day API ---------------------------- */

/* ---------------------------- ALL Event Schedule API ---------------------------- */
export const getAllEventScheduleApi = () =>
  axios.get(MAIN_URL + GET_ALL_EVENT_SCHEDULE_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const addEventScheduleApi = (data) =>
  axios.post(MAIN_URL + ADD_EVENT_SCHEDULE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateEventScheduleApi = (data) =>
  axios.post(MAIN_URL + UPDATE_EVENT_SCHEDULE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const deleteEventScheduleApi = (data) =>
  axios.post(MAIN_URL + DELETE_EVENT_SCHEDULE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getEventScheduleByDayIdApi = (data) =>
  axios.post(MAIN_URL + GET_EVENT_SCHEDULE_BY_DAY_ID_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Event Schedule API ---------------------------- */

/* ---------------------------- ALL Event Presenter API ---------------------------- */
export const getAllEventPresenterApi = () =>
  axios.get(MAIN_URL + GET_ALL_EVENT_PRESENTER_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const addEventPresenterApi = (data) =>
  axios.post(MAIN_URL + ADD_EVENT_PRESENTER_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateEventPresenterApi = (data) =>
  axios.post(MAIN_URL + UPDATE_EVENT_PRESENTER_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const deleteEventPresenterApi = (data) =>
  axios.post(MAIN_URL + DELETE_EVENT_PRESENTER_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getEventPresenterBySessionIdApi = (data) =>
  axios.post(MAIN_URL + GET_EVENT_PRESENTER_BY_SESSION_ID_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Event Presenter API ---------------------------- */

/* ---------------------------- ALL App Settings API ---------------------------- */
export const getAppSettingsApi = () =>
  axios.get(MAIN_URL + GET_APP_SETTINGS_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateAppSettingsApi = (data) =>
  axios.post(MAIN_URL + UPDATE_APP_SETTINGS_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

/* ---------------------------- END App Settings API ---------------------------- */

/* ---------------------------- ALL Sponsor API ---------------------------- */
export const getAllSponsorApi = () =>
  axios.get(MAIN_URL + GET_ALL_SPONSOR_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const addSponsorApi = (data) =>
  axios.post(MAIN_URL + ADD_SPONSOR_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateSponsorApi = (data) =>
  axios.post(MAIN_URL + UPDATE_SPONSOR_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const deleteSponsorApi = (data) =>
  axios.post(MAIN_URL + DELETE_SPONSOR_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ----------------------------  END Sponsor API ---------------------------- */

/* ---------------------------- ALL Blog API ---------------------------- */
export const getAllBlogApi = () =>
  axios.get(MAIN_URL + GET_ALL_BLOG_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const addBlogApi = (data) =>
  axios.post(MAIN_URL + ADD_BLOG_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateBlogApi = (data) =>
  axios.post(MAIN_URL + UPDATE_BLOG_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const deleteBlogApi = (data) =>
  axios.post(MAIN_URL + DELETE_BLOG_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Blog API ---------------------------- */

/* ---------------------------- ALL Contact Us API ---------------------------- */
export const getAllContactUsApi = () =>
  axios.get(MAIN_URL + GET_ALL_CONTACT_US_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Contact Us API ---------------------------- */

/* ---------------------------- ALL Cuponcode API ---------------------------- */
export const getAllCuponcodeApi = () =>
  axios.get(MAIN_URL + GET_ALL_CUPONCODE_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const addCuponcodeApi = (data) =>
  axios.post(MAIN_URL + ADD_CUPONCODE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateCuponcodeApi = (data) =>
  axios.post(MAIN_URL + UPDATE_CUPONCODE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Cuponcode API ---------------------------- */

/* ---------------------------- ALL Order API ---------------------------- */
export const getAllOrderApi = () =>
  axios.get(MAIN_URL + GET_ALL_ORDER_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getIncomeApi = () =>
  axios.get(MAIN_URL + GET_INCOME_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Order API ---------------------------- */

/* ---------------------------- ALL Dashboard API ---------------------------- */
export const getDaywiseIncomeApi = () =>
  axios.get(MAIN_URL + GET_DAYWISE_INCOME_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getLoginStatsApi = () =>
  axios.get(MAIN_URL + GET_LOGIN_STATS_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getTotalCountApi = () =>
  axios.get(MAIN_URL + GET_TOTAL_COUNT_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Dashboard API ---------------------------- */

/* ---------------------------- ALL Theme API ---------------------------- */
export const getThemeApi = () =>
  axios.get(MAIN_URL + GET_THEME_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateThemeApi = (data) =>
  axios.post(MAIN_URL + UPDATE_THEME_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Theme API ---------------------------- */
export const getAppSettings = () => axios.get(MAIN_URL + GET_APP_SETTINGS_API_FAVICON)

/* ---------------------------- ALL Event Sponsor API ---------------------------- */
export const getAllEventSponsorApi = () =>
  axios.get(MAIN_URL + GET_ALL_EVENT_SPONSOR_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const addEventSponsorApi = (data) =>
  axios.post(MAIN_URL + ADD_EVENT_SPONSOR_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateEventSponsorApi = (data) =>
  axios.post(MAIN_URL + UPDATE_EVENT_SPONSOR_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const deleteEventSponsorApi = (data) =>
  axios.post(MAIN_URL + DELETE_EVENT_SPONSOR_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const getEventSponsorByEventIdApi = (data) =>
  axios.post(MAIN_URL + GET_EVENT_SPONSOR_BY_EVENT_ID_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

/* ---------------------------- END Event Sponsor API ---------------------------- */

/* ---------------------------- ALL Popup Image API ---------------------------- */
export const getAllPopupImageApi = () =>
  axios.get(MAIN_URL + GET_ALL_POPUP_IMAGE_API, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const addPopupImageApi = (data) =>
  axios.post(MAIN_URL + ADD_POPUP_IMAGE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updatePopupImageApi = (data) =>
  axios.post(MAIN_URL + UPDATE_POPUP_IMAGE_API, data, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })
/* ---------------------------- END Popup Image API ---------------------------- */
export const getOrderByIdApi = (id) => {
  return axios.post(
    MAIN_URL + GET_ORDER_BY_ID_API,
    { id },
    {
      headers: { Authorization: `Bearer ${Cookies.get('token')}` },
    },
  )
}

/* ---------------------------- role ACESS CONTROL ---------------------------- */


export const createroleApi = (data) =>

  axios.post(MAIN_URL + CREATE_ROLE, data, {
    // headers: { Authorization: `Bearer ${Cookies.get('token')}` },

  })

export const getAllRoleApi = () =>

  axios.get(MAIN_URL + GET_ALL_ROLE, {
    // headers: { Authorization: `Bearer ${Cookies.get('token')}` },

  })

export const updateRoleByIdApi = (data) =>
  axios.post(MAIN_URL + UPDATE_ROLE_ID, data, {
    // headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  }

  )

/* ---------------------------- SCREEN MANAGEMENT ---------------------------- */




export const createScreenApi = (data) =>
  axios.post(MAIN_URL + CREATE_SCREEN, data, {
    // headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })

export const updateScreenByIdApi = (id, data) =>
  axios.post(`${MAIN_URL + UPDATE_SCREEN}/${id}`, data);
// headers: { Authorization: `Bearer ${Cookies.get('token')}` },


export const getAllScreensApi = () =>
  axios.get(MAIN_URL + GET_ALL_SCREENS, {
    // headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })


/* ---------------------------- TICKET CLASS API ---------------------------- */

export const ticketclassApi = (data) =>
  axios.post(MAIN_URL + CREATE_TICKET_CLASS_API, data, {
    // headers: { Authorization: `Bearer ${Cookies.get('token')}` },
  })




/* ---------------------------- TICKET TEMPLATE--------------------------- */
// export const saveTicketTemplateApi = (data) =>

//   axios.post(MAIN_URL + SAVE_TICKET_TEMPLATE_API, data, {
//     // headers: { Authorization: `Bearer ${Cookies.get('token')}` },
//   })

export const saveTicketTemplateApi = (templateData) => {
  if (templateData._id) {
    // Update existing template
    return axios.put(`${MAIN_URL}${SAVE_TICKET_TEMPLATE_API}/${templateData._id}`, templateData);
  } else {
    // Create new template
    return axios.post(`${MAIN_URL}${SAVE_TICKET_TEMPLATE_API}`, templateData);
  }
};

export const getTicketTemplateByIdApi = (templateId) =>
  axios.get(`${MAIN_URL}${GET_TICKET_TEMPLATE_BY_ID_API}/${templateId}`)

export const getTicketTemplateApi = () =>
  axios.get(MAIN_URL + GET_TICKET_TEMPLATE_API, {
  })


export const deleteTicketTemplateApi = (templateId) =>
  axios.delete(`${MAIN_URL}${DELETE_TICKET_TEMPLATE_API}/${templateId}`)

export const duplicateTicketTemplateApi = (templateId) =>
  axios.post(`${MAIN_URL}${DUPLICATE_TICKET_TEMPLATE_API}/${templateId}/duplicate`)





export const getCategory = () => axios.get(MAIN_API + GET_CATEGORY_API);
export const getCity = () => axios.get(MAIN_API + GET_CITY_API);
export const getCount = () => axios.get(MAIN_API + GET_COUNT_API);
export const getFeaturedEvent = () => axios.get(MAIN_API + GET_FEATURED_EVENT_API);
export const getLatestBlog = () => axios.get(MAIN_API + GET_LATEST_BLOG_API);
export const getState = () => axios.get(MAIN_API + GET_STATE_API);

/* ---------------------------- ALL Advertisement/Campaign API ---------------------------- */
const authHeader = () => ({ headers: { Authorization: `Bearer ${Cookies.get('token')}` } })

export const getAdvertisementMetaApi = () =>
  axios.get(MAIN_URL + GET_ADVERTISEMENT_META_API, authHeader())

export const getAdvertisementSummaryApi = () =>
  axios.get(MAIN_URL + GET_ADVERTISEMENT_SUMMARY_API, authHeader())

export const getAllAdvertisementApi = (params) =>
  axios.get(MAIN_URL + GET_ALL_ADVERTISEMENT_API, { ...authHeader(), params })

export const getAdvertisementByIdApi = (id) =>
  axios.get(`${MAIN_URL}${GET_ADVERTISEMENT_BY_ID_API}/${id}`, authHeader())

export const addAdvertisementApi = (data) =>
  axios.post(MAIN_URL + ADD_ADVERTISEMENT_API, data, authHeader())

export const updateAdvertisementApi = (data) =>
  axios.post(MAIN_URL + UPDATE_ADVERTISEMENT_API, data, authHeader())

export const duplicateAdvertisementApi = (id) =>
  axios.post(MAIN_URL + DUPLICATE_ADVERTISEMENT_API, { id }, authHeader())

export const publishAdvertisementApi = (id) =>
  axios.post(MAIN_URL + PUBLISH_ADVERTISEMENT_API, { id }, authHeader())

export const pauseAdvertisementApi = (id) =>
  axios.post(MAIN_URL + PAUSE_ADVERTISEMENT_API, { id }, authHeader())

export const resumeAdvertisementApi = (id) =>
  axios.post(MAIN_URL + RESUME_ADVERTISEMENT_API, { id }, authHeader())

export const archiveAdvertisementApi = (id) =>
  axios.post(MAIN_URL + ARCHIVE_ADVERTISEMENT_API, { id }, authHeader())

export const deleteAdvertisementApi = (id) =>
  axios.post(MAIN_URL + DELETE_ADVERTISEMENT_API, { id }, authHeader())

// `onUploadProgress` is optional — pass a callback(percent) to drive a progress bar in the uploader UI.
export const uploadAdvertisementCreativeApi = (formData, onUploadProgress) =>
  axios.post(MAIN_URL + UPLOAD_ADVERTISEMENT_CREATIVE_API, formData, {
    ...authHeader(),
    onUploadProgress: onUploadProgress
      ? (event) => onUploadProgress(Math.round((event.loaded * 100) / (event.total || event.loaded || 1)))
      : undefined,
  })

export const testAdvertisementTargetingApi = (id, context) =>
  axios.post(MAIN_URL + TEST_ADVERTISEMENT_TARGETING_API, { id, context }, authHeader())

// params: { from, to (YYYY-MM-DD), serviceId, placement, sourceType, campaign }
export const getAdvertisementAnalyticsApi = (params) =>
  axios.get(MAIN_URL + GET_ADVERTISEMENT_ANALYTICS_API, { ...authHeader(), params })

// Resolves to a Blob (text/csv) — the caller triggers the download.
export const exportAdvertisementAnalyticsApi = (params) =>
  axios.get(MAIN_URL + EXPORT_ADVERTISEMENT_ANALYTICS_API, { ...authHeader(), params, responseType: 'blob' })
/* ---------------------------- END Advertisement/Campaign API ---------------------------- */

/* ---------------------------- ALL Customer App Service API ---------------------------- */
export const getAppServiceMetaApi = () =>
  axios.get(MAIN_URL + GET_APP_SERVICE_META_API, authHeader())

export const getAllAppServiceApi = () =>
  axios.get(MAIN_URL + GET_ALL_APP_SERVICE_API, authHeader())

export const getAppServiceByIdApi = (id) =>
  axios.get(`${MAIN_URL}${GET_APP_SERVICE_BY_ID_API}/${id}`, authHeader())

export const addAppServiceApi = (data) =>
  axios.post(MAIN_URL + ADD_APP_SERVICE_API, data, authHeader())

export const updateAppServiceApi = (data) =>
  axios.post(MAIN_URL + UPDATE_APP_SERVICE_API, data, authHeader())

export const reorderAppServiceApi = (orders) =>
  axios.post(MAIN_URL + REORDER_APP_SERVICE_API, { orders }, authHeader())

export const deleteAppServiceApi = (id) =>
  axios.post(MAIN_URL + DELETE_APP_SERVICE_API, { id }, authHeader())

// `onUploadProgress` is optional — pass a callback(percent) to drive a progress bar.
export const uploadAppServiceIconApi = (formData, onUploadProgress) =>
  axios.post(MAIN_URL + UPLOAD_APP_SERVICE_ICON_API, formData, {
    ...authHeader(),
    onUploadProgress: onUploadProgress
      ? (event) => onUploadProgress(Math.round((event.loaded * 100) / (event.total || event.loaded || 1)))
      : undefined,
  })
/* ---------------------------- END Customer App Service API ---------------------------- */

/* ---------------------------- ALL Customer App Theme API ---------------------------- */
export const getAppThemeApi = () =>
  axios.get(MAIN_URL + GET_APP_THEME_API, authHeader())

export const updateAppThemeApi = (data) =>
  axios.post(MAIN_URL + UPDATE_APP_THEME_API, data, authHeader())

export const resetAppThemeApi = () =>
  axios.post(MAIN_URL + RESET_APP_THEME_API, {}, authHeader())
/* ---------------------------- END Customer App Theme API ---------------------------- */

/* ---------------------------- ALL Customer App Version API ---------------------------- */
export const getAppVersionApi = () =>
  axios.get(MAIN_URL + GET_APP_VERSION_API, authHeader())

export const updateAppVersionApi = (data) =>
  axios.post(MAIN_URL + UPDATE_APP_VERSION_API, data, authHeader())
/* ---------------------------- END Customer App Version API ---------------------------- */

export const getCityByStateId = (data) => axios.post(MAIN_API + GET_CITY_BY_STATE_ID_API, data);
export const getVenueByCityId = (data) => axios.post(MAIN_API + GET_VENUE_BY_CITY_ID_API, data);
export const getSponsor = () => axios.get(MAIN_API + GET_SPONSOR_API);
